var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_7041)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.01 8.90984C14.42 8.42984 13.51 6.73984 14 5.13984C14.48 3.54984 16.17 2.63984 17.77 3.12984C19.36 3.60984 20.27 5.29984 19.78 6.89984C19.3 8.48984 17.6 9.38984 16.01 8.90984ZM3.15956 13.6299C2.62956 15.2099 3.47956 16.9299 5.05956 17.4599C6.63956 17.9899 8.35956 17.1399 8.88956 15.5599C9.41956 13.9799 8.56956 12.2599 6.98956 11.7299C5.40956 11.1999 3.68956 12.0499 3.15956 13.6299ZM7.45956 15.0699C7.18956 15.8599 6.33956 16.2899 5.54956 16.0199C4.75956 15.7499 4.32956 14.8999 4.59956 14.1099C4.86956 13.3199 5.71956 12.8899 6.50956 13.1599C7.29956 13.4299 7.72956 14.2799 7.45956 15.0699ZM14.4096 21.2703C14.2096 21.2303 14.0496 21.0803 14.0096 20.8803L12.5996 13.1003C12.5696 12.9203 12.6396 12.7303 12.7996 12.6203C12.8796 12.5603 12.9796 12.5303 13.0696 12.5303C13.1596 12.5303 13.2396 12.5503 13.3096 12.6003L20.1196 16.6203C20.2896 16.7203 20.3896 16.9203 20.3496 17.1203C20.3096 17.3203 20.1496 17.4703 19.9496 17.5003L16.5696 18.0303L14.8996 21.0203C14.8096 21.1703 14.6496 21.2703 14.4796 21.2703H14.4096ZM10.3001 12.39C10.0501 12.42 9.79012 12.33 9.62012 12.12C9.35012 11.8 9.40013 11.32 9.72012 11.06L10.1101 10.74C10.4301 10.48 10.9101 10.52 11.1701 10.84C11.4401 11.16 11.3901 11.64 11.0701 11.9L10.6801 12.22C10.5701 12.31 10.4301 12.37 10.2901 12.39H10.3001ZM12.1104 10.0597C12.2804 10.2697 12.5404 10.3597 12.7904 10.3297H12.7804C12.9204 10.3097 13.0604 10.2497 13.1704 10.1597L13.5604 9.8397C13.8804 9.5797 13.9304 9.0997 13.6604 8.7797C13.4004 8.4597 12.9204 8.4097 12.6004 8.6797L12.2104 8.9997C11.8904 9.2597 11.8404 9.7397 12.1104 10.0597Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_7041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.37,
    height: 18.28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoJoin);
export default __webpack_public_path__ + "static/media/ico-join.be047375b4bb204d9aa1f40235f9c5b3.svg";
export { ForwardRef as ReactComponent };